module.exports = {
  name: "MeetusVR",
  desc: "MeetusVR - Dashboard",
  prefix: "MeetusVR",
  footerText: `MeetusVR All Rights Reserved ${new Date().getFullYear()}`,
  logoText: "MeetusVR",
};
